<script setup lang="ts">
  import Icon from '@/common/ui/components/Icon.vue';
  import type {GitProviderHandle} from '@/console';
  import {computed} from 'vue';

  const props = withDefaults(
    defineProps<{
      provider?: GitProviderHandle;
    }>(),
    {provider: 'fake'}
  );

  const providerIcon = computed(() => {
    if (!props.provider) {
      return 'fake';
    }

    if (props.provider === 'github_app') {
      return 'github';
    }
    return props.provider;
  });
</script>

<template>
  <div class="aspect-square flex justify-center items-center">
    <div
      v-if="providerIcon === 'fake'"
      class="w-3/4 h-3/4 rounded-full bg-gray-200 text-center flex flex-col justify-center text-gray-500"
    >
      <svg
        id="a"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
      >
        <path
          d="M9.88,7.52c1.17-1.03,3.07-1.03,4.24,0,1.17,1.02,1.17,2.69,0,3.71-.2.18-.43.33-.67.44-.74.36-1.45,1-1.45,1.83v.75M12,17.25h0s0,0,0,0h0Z"
          style="
            fill: none;
            stroke: currentColor;
            stroke-linecap: round;
            stroke-linejoin: round;
            stroke-width: 1.5px;
          "
        />
      </svg>
    </div>
    <Icon v-else :icon="providerIcon" class="w-8 h-full" />
  </div>
</template>

<style scoped></style>
